export class WBCommonException implements Error {
    public name: string;

    constructor(public message: string) {
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/exception/entity/exception.ts